var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEncryptedAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-516v-244l320-120 320 120v200h-80v-144l-240-90-240 90v188q0 45 11.5 90t32.5 86.5q21 41.5 50.5 76.5t65.5 61v92q-107-55-173.5-165.5T160-516Zm320 22Zm180 334h40v-100h100v-40H700v-100h-40v100H560v40h100v100Zm20 80q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80ZM480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncryptedAddCircle);
export default __webpack_public_path__ + "static/media/encrypted-add-circle.da9021905a07d21a52e4b5b01f724817.svg";
export { ForwardRef as ReactComponent };